import {
  DefaultButton,
  PrimaryButton,
  Spinner,
  SpinnerSize,
} from 'office-ui-fabric-react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ScrollableAnchor from 'react-scrollable-anchor';
import { NOTIFICATIONTYPE_HEARING_CONCLUSION_PUBLISHED } from '../../../../../../constants/api';
import { resolveFileExtensionFromMime } from '../../../../../../utilities/files';
import { mapFileListItemToFile } from '../../../../../../utilities/mapperFunctions';
import { resolveValidationRules } from '../../../../../../utilities/validationRuleHelper';
import { AppendixUpload } from '../../../AppendixUpload';
import { TextWithTemplates } from '../../../TextWithTemplates';
import { UpdateNotificationContentPanel } from '../../../UpdateNotificationContentPanel';

const ConclusionFieldWrite = ({
  hearingId,
  conclusionTextValue,
  onChange,
  templateOptions,
  onSaveConclusion,
  onSaveAndFinalize,
  onEditNotification,
  files,
  onChangeFiles,
  onDownloadFile,
  validationEntity,
  showSpinner,
}) => {
  const { t: translator } = useTranslation();
  const [isHearingAnswered, setIsHearingAnswered] = useState(false);

  const { maxFileSize, allowedFileTypes } = resolveValidationRules(
    validationEntity,
  );

  const allowedFileExtensions = useMemo(
    () =>
      allowedFileTypes?.map(resolveFileExtensionFromMime).join(', ') ||
      translator('pages.hearingDetails.allFileTypesAllowed'),
    [allowedFileTypes, translator],
  );

  const onChangeTemplate = (_, value) => {
    onChange(value.text || '');
    setIsHearingAnswered(true);
  };
  const onDeleteFile = (value) => {
    if (value) {
      onChangeFiles(mapFileListItemToFile(value), true);
      setIsHearingAnswered(true);
    }
  };

  return (
    <ScrollableAnchor id="conclusion">
      <div
        className="create-hearing-form-field"
        aria-label={translator('ariaLabel.conclusionFieldWrite')}
      >
        <hr className="create-hearing-header-hr" />
        <h2 className="h2-style">
          {translator('pages.hearingDetails.conclusionWrite')}
        </h2>
        <TextWithTemplates
          textValue={conclusionTextValue}
          templateOptions={templateOptions}
          onChangeText={onChange}
          onChangeDropdown={onChangeTemplate}
          setIsHearingAnswered={setIsHearingAnswered}
          placeHolderText={translator(
            'pages.hearingDetails.conclusionWritePlaceholder',
          )}
        />
        <AppendixUpload
          onUploadFiles={onChangeFiles}
          maxFileSize={maxFileSize}
          fileItems={files}
          onDownloadFile={onDownloadFile}
          onDeleteFile={onDeleteFile}
          allowMultiple={true}
          allowedFileTypes={allowedFileExtensions}
          setIsHearingAnswered={setIsHearingAnswered}
        />
        <UpdateNotificationContentPanel
          hearingId={hearingId}
          notificationTypeValue={NOTIFICATIONTYPE_HEARING_CONCLUSION_PUBLISHED}
        />
        <div className="conclusion-buttons">
          {showSpinner && <Spinner size={SpinnerSize.large} />}
          <DefaultButton
            className="save-conclusion-button"
            text={translator('pages.hearingDetails.editConclusionNotification')}
            onClick={onEditNotification}
            disabled={showSpinner}
          />
          <PrimaryButton
            className="save-conclusion-button"
            text={translator('global.save')}
            onClick={onSaveConclusion}
            disabled={!isHearingAnswered || showSpinner}
          />
          <PrimaryButton
            text={translator(
              'pages.hearingDetails.conclusionSaveAndEndHearing',
            )}
            className="save-conclusion-button"
            onClick={onSaveAndFinalize}
            disabled={!isHearingAnswered || showSpinner}
          />
        </div>
      </div>
    </ScrollableAnchor>
  );
};

export { ConclusionFieldWrite };
